<template>
  <div class="forget_password">
    <div class="forget_password_content content_auto">
      <div class="forget_password_card">
        <div class="card">
          <div class="card_head">
            <h1>{{ $t('重置登录密码') }}</h1>
          </div>
          <div class="card_body">
            <div class="warning_box">
              <SvgIcon name="gangtan"></SvgIcon>
              <p class="warning">
                {{ $t('重置登录密码后，24小时内禁止提币') }}
              </p>
            </div>
            <el-form :model="formData" :rules="rules" ref="ruleFormRef">
              <el-form-item
                :key="active"
                :rules="[
                  {
                    required: true,
                    message:
                      active === 0
                        ? $t('请输入手机号码')
                        : $t('请输入邮箱地址'),
                    trigger: 'blur'
                  }
                ]"
                prop="account"
                :class="{ mobileFormItem: active === 0 }"
              >
                <SignTab :active.sync="active" />
                <div class="account-box">
                  <div class="input_box">
                    <InternationalCode
                      v-if="active === 0"
                      containerWidth="100px"
                      isCountryDialCode
                      @selectCountry="onSelectCountry"
                    ></InternationalCode>
                    <el-input
                      v-model="formData.account"
                      :placeholder="
                        active === 0 ? $t('手机号码') : $t('请输入邮箱地址')
                      "
                      size="large"
                      :class="{ 'mobile-input': active === 0 }"
                    />
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="password">
                <div class="safety_item">
                  <h3>{{ $t('新密码') }}</h3>
                  <div class="verify_code_box">
                    <el-input
                      type="password"
                      v-model="formData.password"
                      :placeholder="$t('请输入新密码')"
                    ></el-input>
                  </div>
                </div>
              </el-form-item>

              <el-form-item prop="passwordAgain">
                <div class="safety_item">
                  <h3>{{ $t('确认密码') }}</h3>
                  <div class="verify_code_box">
                    <el-input
                      type="password"
                      v-model="formData.passwordAgain"
                      :placeholder="$t('请再次输入新密码')"
                    ></el-input>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="card_foot">
            <el-button
              :loading="confirmLoading"
              type="primary"
              @click="handleNextstep()"
            >
              {{ $t('下一步') }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <SixValidation
      v-model="reverseSix"
      :dataList="formData"
      type="forgetPassword"
    ></SixValidation>
  </div>
</template>
<script>
import SignTab from '@/views/sign/components/SignTab'
import SixValidation from '@/views/sign/components/SixValidation'
import getCode from '@/views/sign/mixin/getCode'
import InternationalCode from '@/components/internationalCode/index.vue'

export default {
  name: 'ResetPassword',
  components: {
    SignTab,
    InternationalCode,
    SixValidation
  },
  mixins: [getCode],
  data() {
    const validPasswordAgain = (_, value, callback) => {
      if (value !== this.formData.password) {
        callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    const validPassword = (_, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('请输入密码')))
      }
      callback()
    }
    return {
      active: 0,
      confirmLoading: false,
      formData: {
        areaCode: '',
        account: '',
        password: '',
        passwordAgain: ''
      },
      rules: {
        password: [
          { required: true, validator: validPassword, trigger: 'blur' }
        ],
        passwordAgain: [{ validator: validPasswordAgain, trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSelectCountry(country) {
      this.formData.areaCode = country.areaCode
    },
    async handleNextstep() {
      await this.$refs.ruleFormRef.validate()
      this.getCaptcha({
        account: this.formData.account,
        areaCode: this.formData.areaCode,
        type: 'forgetPassword'
      })
      // this.$refs.ruleFormRef.validate((valid) => {
      //   if (valid) {
      //     this.confirmLoading = true
      //     bianSecurityResetPassword(this.formData)
      //       .then((res) => {
      //         this.confirmLoading = false
      //         const resData = res.data.data
      //         this.validationList.mobile = resData.enablePhoneCheck
      //         this.validationList.email = resData.enableEmailCheck
      //         this.validationList.google = resData.enableGoogleCheck
      //         this.transferData.mobile = resData.mobilePhone
      //         this.transferData.email = resData.email
      //         this.transferData.areaCode = resData.areaCode
      //         this.reverseForget = false
      //         this.reverseSafety = true
      //       })
      //       .catch((err) => {
      //         this.confirmLoading = false
      //         this.$Message.error({
      //           message: err.data.message
      //         })
      //       })
      //   }
      // })
    },
    switchDialog() {
      this.reverseSafety = false
    }
  }
}
</script>
<style lang="less" scoped>
@import './components/index.less';
.forget_password {
  height: calc(100vh - 60px);
  background: rgba(19, 22, 37, 1);
  .forget_password_content {
    overflow: hidden;
    .forget_password_card {
      margin-top: 130px;
      .card {
        margin: 0 auto;
        width: 540px;
        background: rgba(255, 255, 255, 1);
        border-radius: 20px;
        .card_head {
          padding: 45px 40px 0 40px;
          h1 {
            height: 33px;
            font-size: 24px;
            font-weight: 500;
            font-family: PingFangSC-Medium, 'PingFang SC';
            color: rgba(51, 51, 51, 1);
            line-height: 33px;
            text-align: center;
          }
        }
        /deep/ .card_body {
          .dialog_mixin();
          .el-form {
            .el-form-item {
              margin-bottom: 20px;

              .tabs_box {
                margin-top: 10px;
              }
              .account-box {
                margin-top: 10px;
                .input_box {
                  margin-top: 0;
                  display: flex;
                  .mobile-input {
                    margin-left: 10px;
                  }
                }
              }
            }
          }
        }
        .card_foot {
          padding: 40px 40px 30px;
          .element_button_mixin(
            @padding: 13px 28px,
            @width: 100%,
            @fontSize: 18px,
            @borderRadius: 2px
          );
        }
      }
    }
  }
}
</style>
